import { initConfiguration } from '@sas/nova-core/config';

export const VASDK_APP_NAME = 'SAS Visual Analytics SDK';

/**
 * Prevents nova-core from making calls to Viya
 */
export function initNovaCore() {
  initConfiguration({
    appName: VASDK_APP_NAME,
    disableConfigurationEndPoint: true,
  });
  (window as any).sas.axiosPreventFetchAcceptLocale = true;
}
